import { render, staticRenderFns } from "./VContentHeaderDefault.vue?vue&type=template&id=ec984d78"
import script from "./VContentHeaderDefault.vue?vue&type=script&lang=js"
export * from "./VContentHeaderDefault.vue?vue&type=script&lang=js"
import style0 from "./VContentHeaderDefault.vue?vue&type=style&index=0&id=ec984d78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports